import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { get } from 'lodash/fp';

import { useModal } from '../../../../hooks';
import SignatureDialog from '../SignatureDialog';

const S = {
  Button: styled.button.attrs(({ position }) => ({
    style: {
      top: `${position.y}%`,
      left: `${position.x}%`,
    },
  }))`
    position: absolute;
    cursor: pointer;
  `,
  Image: styled.img`
    width: 80px;
  `,
  Signature: styled.button.attrs(({ position }) => ({
    style: {
      top: `${position.y}%`,
      left: `${position.x}%`,
    },
  }))`
    position: absolute;
    min-width: ${({ large }) => (large ? 120 : 80)}px;
    padding: ${({ large }) => (large ? '8px 16px 9px' : '3px 8px')};
    border-radius: 24px;
    color: ${({ theme }) => theme.palette.grey[900]};
    background-color: ${({ error, theme }) => theme.palette.status[error ? 'error' : 'note'].background};
    font-size: ${({ large, theme }) => theme.typography.pxToRem(large ? 15 : 13)};
    font-weight: 700;
    text-align: right;
    line-height: 1.54;
    cursor: pointer;
    ::before {
      content: '';
      position: absolute;
      top: 50%;
      left: ${({ large }) => (large ? 12 : 8)}px;
      transform: translateY(-50%);
      width: ${({ large }) => (large ? 16 : 8)}px;
      height: ${({ large }) => (large ? 16 : 8)}px;
      border-radius: 50%;
      background-color: ${({ error, theme }) => theme.palette.status[error ? 'error' : 'note'].main};
    }
  `,
};

const SignatureField = ({
  field, form, large, signature,
}) => {
  const [signatureURL, setSignatureURL] = useState(null);

  const [open, openDialog, closeDialog] = useModal();

  const error = useMemo(() => !!(
    get(field.name, form.errors) && get(field.name, form.touched)
  ), [field.name, form.errors, form.touched]);

  const handleSign = useCallback((dataURL) => {
    setSignatureURL(dataURL);

    form.setFieldValue(field.name, true);
  }, [field.name, form]);

  return (
    <>
      {signatureURL
        ? (
          <S.Button
            type="button"
            name={signature.number}
            position={signature.position}
            onClick={openDialog}
          >
            <S.Image
              src={signatureURL}
              alt={`전자서명 ${signature.number}`}
              large={large}
            />
          </S.Button>
        )
        : (
          <S.Signature
            type="button"
            name={signature.number}
            position={signature.position}
            error={error}
            large={large}
            onClick={openDialog}
          >
            전자 서명
          </S.Signature>
        )}
      <SignatureDialog open={open} onClose={closeDialog} onSign={handleSign} />
    </>
  );
};

SignatureField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.bool,
  }).isRequired,
  form: PropTypes.shape({
    errors: PropTypes.shape({}).isRequired,
    touched: PropTypes.shape({}).isRequired,
    setFieldValue: PropTypes.func.isRequired,
  }).isRequired,
  large: PropTypes.bool,
  signature: PropTypes.shape({
    number: PropTypes.number.isRequired,
    position: PropTypes.shape({
      x: PropTypes.number.isRequired,
      y: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
};

SignatureField.defaultProps = {
  large: false,
};

export default SignatureField;
